<template>
  <div class="text-center">
    <v-card class="color_volume">
      <v-card-text>
        <v-simple-table  light dense style="background-color: #fff; " >
          <template v-slot:default>
            <tbody>
            <tr><td><strong>Дни\Часы</strong></td><td v-for="(tdd,iii) in arr[0]" :key="iii" style="margin-right: 4px;"><strong>{{ iii+1 }}</strong></td></tr>
            <tr :key="key" v-for="(tr,key) in arr">
              <td style="margin-right: 4px;"><strong>{{ key + 1 }}</strong></td>
              <td class="tdclass" :style="'background-color:'+td.color" v-for="(td,i) in tr"
                  :key="i">{{ td.value }}
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>

export default {
  name: 'VolumeModal',
  props: ['arr'],

  data: () => ({
    dialog: false,
  }),
}
</script>
<style>
html {
  overflow:hidden;
}
.color_volume .v-data-table__wrapper{
  height: calc(100vh - 116px) !important;
  overflow-y: scroll !important;
  overflow-x: scroll !important;
}
</style>
<style scoped>
.v-data-table{
  width: 100vw;
}




@media only screen and (min-width : 1000px) {
  .v-data-table{
    overflow: visible;
    display: block;
    width: calc(100vw - 340px);

  }
}





.tdclass {
  padding-left: 6px !important; padding-right: 6px !important; font-size: 12px !important;
  width: 30px !important;
}
td {
  height: 16px !important;
}
</style>
